import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GetRequestActivityByIdGQL } from '../../../../generated/cloudapigql';
import { HeaderTemplateData } from '../dialog-data.interface';
import { SharedService } from '../../../../services/shared.service';

// export interface DialogData {
//     title: [];
//     type: number;
//     amount: number;
//     att: any [];
// }

export interface activityDetail extends HeaderTemplateData{
  activityId:string;
}

@UntilDestroy()
@Component({
  selector: 'activity-detail-dialog',
  templateUrl: 'activity-detail-dialog.html',
  styleUrls: ['activity-detail-dialog.scss']
})

export class ActivityDetailDialog implements OnInit {
  result: any = {};

  header: HeaderTemplateData;
  constructor(
    public dialogRef: MatDialogRef<ActivityDetailDialog>,
    private getRequestActivityByIdGQL: GetRequestActivityByIdGQL,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    public shareService:SharedService,
  ) {
    if (this._data != null) {
      this.header = _data

      let requestActivityId = this._data.activityId;

      if (requestActivityId) {

        this.getRequestActivityByIdGQL.fetch({
          ActivityId: requestActivityId
        }).pipe(untilDestroyed(this)).subscribe(x => {
          this.result = x.data.requestActivityById;

          if (this.result.requestFollowUp) {
            this.result.categoryType = "Follow Up";
          } else if (this.result.requestQuotation) {
            this.result.categoryType = "Quotation";
          } else if (this.result.requestEstimation) {
            this.result.categoryType = "Estimated Resolution";
          } else {
            this.result.categoryType = "Assignment";

          }
        }, error => {
        })

      }
    }
  }

  ngOnInit() {
  }

  downloadQuotation(url: string) {
    // window.open(url);
    const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', url);
        link.setAttribute('download', 'download');
        document.body.appendChild(link);
        link.click();
  }

}
